import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { Paper, Stack, Typography } from '@mui/material';
import { NotificationOff } from '~/icons';
import { useAppDispatch } from '~/redux';
import { ModalTypesEnum, openModal } from '~/redux/slices/modalSlice';

const EmptyBanner = () => {
  const dispatch = useAppDispatch();

  return (
    <Paper elevation={2} sx={{ p: 4, maxWidth: 524, minWidth: 300 }}>
      <Typography variant="headingS" mb="3rem" color="#0C0CA5">
        Notice Banner
      </Typography>
      <Stack spacing={3} mt={3} alignItems="center">
        <NotificationOff fill="#0000004D" />
        <Typography variant="bodyLargeStrong">No banner has configured</Typography>
        <Typography align="center" variant="bodyLarge">
          Create a banner to notify users about upcoming announcements.
        </Typography>
        <CustomButton
          onClick={() => {
            dispatch(openModal({ type: ModalTypesEnum.NOTICE_BANNER }));
          }}
          label="Add Banner"
        />
      </Stack>
    </Paper>
  );
};

export default EmptyBanner;
